import { useState, useCallback } from "react";
import { Progress } from "../../panels";
import { UseProgressPanelReturn } from "./types";

const getTitleFromAction = (action: "create" | "edit" | "duplicate") => {
  switch (action) {
    case "edit":
      return "Edit entry";
    case "duplicate":
      return "Duplicate entry";
    case "create":
    default:
      return "Add entry";
  }
};

export const useProgressPanel = (): UseProgressPanelReturn => {
  const [panel, setPanel] = useState<UseProgressPanelReturn["panel"]>({
    action: "create",
    isOpen: false,
    progress: undefined,
  });

  const openCreatePanel = useCallback(() => {
    setPanel({ action: "create", isOpen: true, progress: undefined });
  }, []);

  const openEditPanel = useCallback((progress: Progress) => {
    setPanel({ action: "edit", isOpen: true, progress });
  }, []);

  const openDuplicatePanel = useCallback((progress: Progress) => {
    setPanel({ action: "duplicate", isOpen: true, progress });
  }, []);

  const closePanel = useCallback(() => {
    setPanel((prev) => ({ ...prev, isOpen: false, progress: undefined }));
  }, []);

  const getPanelTitle = useCallback(() => {
    return getTitleFromAction(panel.action);
  }, [panel.action]);

  return {
    panel,
    openCreatePanel,
    openEditPanel,
    openDuplicatePanel,
    closePanel,
    getPanelTitle,
  };
};
